import React from 'react';
import classNames from 'classnames';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import { withStyles } from '@mui/styles';
import SendIcon from '@mui/icons-material/Send';
import runtimeEnv from '@mars/heroku-js-runtime-env';
import axios from 'axios';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css'
import swal from 'sweetalert';
import ReactGA from 'react-ga';

const API_BASE = runtimeEnv().REACT_APP_API_URL;
const WEB_PLATFORM_WIDTH = 768;

const styles = theme => ({
  root: {
    backgroundColor: "white",
    height: "100%",
    padding: "10px",
    [theme.breakpoints.up('sm')]: {
      textAlign: "center",
    }
  },
  logo: {
    width: "100%",
    height: "20vh",
    [theme.breakpoints.up('sm')]: {
      width: "40%",
    }
  },
  header: {
    fontSize: "3rem",
    fontWeight: "bold",
    textAlign: "center",
    fontFamily: "News Cycle",
    textTransform: "uppercase",
    letterSpacing: "1.5px"
  },
  container: {
    width: "90%",
    margin: "auto",
    [theme.breakpoints.up('sm')]: {
      textAlign: "center",
    }
  },
  description: {
    fontWeight: "400",
    fontSize: "13px"
  },
  input: {
    border: "1px solid black",
    width: "-webkit-fill-available",
    padding: "3px",
    boxShadow: "10px 10px 10px 0 rgb(50 50 93 / 10%), 0 3px 6px 0 rgb(0 0 0 / 7%)",
    paddingLeft: "15%",
    paddingRight: "15%"
  },
  inputHelper: {
    textAlign: "center",
    marginTop: "5px"
  },
  autoMargin: {
    display: "block",
    margin: "auto"
  },
  button: {
    backgroundColor: "#6091fb",
    color: "white",
    textTransform: "capitalize",
    fontSize: "16px",
    borderRadius: "5px",
    fontWeight: "400",
    paddingLeft: "15px",
    paddingRight: "15px",
    boxShadow: "10px 10px 10px 0 rgb(50 50 93 / 10%), 0 3px 6px 0 rgb(0 0 0 / 7%)",
  },
  sendIcon: {
    fontSize: "24px",
    marginLeft: "5px"
  },
  pageFooter: {
    justifyContent: "center",
    fontSize: "12px",
    textAlign: "center",
    // position: "fixed",
    // bottom: "0",
    width: "100%;"
  },
  footerInnerImage: {
    margin: "auto",
    width: "110px"
  },
  footerLinks: {
    margin: "5px"
  },
  footerLink: {
    margin: "5px",
    textDecoration: "underline !important",
    fontWeight: "500"
  },
  textFieldFont: {
    fontSize: "22px",
    "&::placeholder": {
      color: "black"
    }
  },
  textCenter: {
    width: "100%",
    textAlign: "center"
  },
  linkWithoutUnderline: {
    textDecoration: "none"
  },
  marginTop: {
    marginTop: "3vh"
  },
  extraMarginTop: {
    marginTop: "5vh"
  },
  marginBottom: {
    marginBottom: "3vh"
  },
  checkboxLabel: {
    fontSize: "11px !important",
    display: "contents"
  },
  font16: {
    fontSize: "16px"
  },
  error: {
    color: "red"
  }
});

const OptInSplash = ({ hotel_id, settings, classes }) => {
  const [optInEnabled, setOptInEnabled] = React.useState(settings.must_opt_in_enabled);
  const [mobileNumber, setMobileNumber] = React.useState('');
  const [error, setError] = React.useState(false);

  const isMobileWidth = () => {
    return window.innerWidth < WEB_PLATFORM_WIDTH;
  }

  ReactGA.pageview(window.location.pathname + window.location.search);

  const inputStyles = {
    borderRadius: "2px",
    width: isMobileWidth() ? "-webkit-fill-available" : "40%",
    border: "1pt solid black",
    boxShadow: "10px 10px 10px 0 rgb(50 50 93 / 10%), 0 3px 6px 0 rgb(0 0 0 / 7%)",
    fontSize: "22px",
    color: settings.page_text_color,
    marginTop: "3vh",
    paddingTop: "15px",
    paddingBottom: "15px",
    paddingLeft: "11%",
    borderColor: error ? "red" : "black"
  }

  const handleSubmit = (event) => {
    event.preventDefault();

    ReactGA.event({
      category: 'User',
      action: 'Clicked on CTA button'
    });

    if (!mobileNumber) {
      return setError(true);
    }
    let params = {
      opt_in_enabled: optInEnabled,
      mobile_number: `+${mobileNumber}`.replace(/[^\d\+]/g, ""),
      hotel_id: hotel_id
    };

    axios.post(`${API_BASE}/visits`, null, { params: params })
      .then((resp) => {
        let _swalArgs = {
          title: "Response Recorded",
          text: "Thanks for your response!",
          icon: "success"
        };

        setMobileNumber('');
        setOptInEnabled(settings.must_opt_in_enabled);

        swal(_swalArgs)

        window.location.replace(settings.redirect_url);
      }).catch((err) => {
        let _swalArgs = {
          title: "Something went wrong!",
          text: "Please contact us to get this fixed.",
          icon: "error"
        };
        swal(_swalArgs)

        window.location.replace(settings.redirect_url);
      });
  }

  const changeOptInCheckbox = () => {
    setOptInEnabled(settings.must_opt_in_enabled ? true : !optInEnabled)

    ReactGA.event({
      category: 'User',
      action: `Marked opt-in messaging option ${optInEnabled}`
    });
  }


  return (
    <div
      className={classNames(classes.root)}
      style={{
        background: settings.page_background_color,
        color: settings.page_text_color
      }}
    >
      <img className={classNames(classes.logo)} src={settings.logo_url} />
      <div className={classNames(classes.container)}>
        <div className={classNames(classes.header, classes.marginTop, classes.marginBottom)}>{settings.header}</div>
        <div className={classNames(classes.description, classes.marginTop, classes.marginBottom)}>{settings.description}</div>
        <PhoneInput
          country={'us'}
          value={mobileNumber}
          InputProps={{ disableUnderline: true, classes: { input: classNames(classes.textFieldFont) } }}
          onChange={(phone_number) => { setError(false); setMobileNumber(phone_number) }}
          inputStyle={inputStyles}
        />
        { error && <div className={classNames(classes.inputHelper, classes.marginBottom, classes.error)}>Mobile Number is Required</div> }
        <div className={classNames(classes.inputHelper, classes.marginBottom)}>Enter Mobile Phone #</div>
        <div className={`${classes.textCenter} ${classes.marginTop, classes.marginBottom}`}>
          <FormControlLabel
            className={classNames(classes.autoMargin)}
            control={<Checkbox value={optInEnabled} checked={optInEnabled} onChange={ changeOptInCheckbox } name="agreement" />}
            label={
              <span
                className={classes.checkboxLabel}
                style={{ color: settings.page_text_color }}
              >
                {settings.opt_in_clause}
              </span>
            }
          />
        </div>
        <IconButton
          className={classNames(classes.button, classes.autoMargin, classes.extraMarginTop, classes.marginBottom)}
          style={{
            background: settings.button_background_color,
            color: settings.button_text_color
          }}
          onClick={handleSubmit}
        >
          {settings.primary_button_text}
          <SendIcon className={classNames(classes.sendIcon)} />
        </IconButton>

        <div className={classNames(classes.textCenter, classes.extraMarginTop, classes.marginBottom, classes.font16)}>
          <a
            className={classNames(classes.linkWithoutUnderline)}
            style={{ color: settings.page_text_color }}
            href={settings.redirect_url}
            onClick={() => { ReactGA.event({ category: 'User', action: 'Clicked on Alternate button' }); }}
          >
            {settings.secondary_button_text}
          </a>
        </div>
      </div>
      <footer className={classNames(classes.pageFooter, classes.extraMarginTop)}>
        <img className={classNames(classes.footerInnerImage)} src="/assets/images/logos/gm_logo_green_grey.svg" />
        <div className={classNames(classes.footerLinks)}>
          <a style={{ color: settings.page_text_color }} className={classNames(classes.footerLink)} href="https://www.gomoment.com/msa/"> Terms</a>
          <a style={{ color: settings.page_text_color }} className={classNames(classes.footerLink)} href="https://www.gomoment.com/privacy/"> Privacy</a>
        </div>
        <p>© { new Date().getFullYear() } Go Moment, Inc. All Rights Reserved.</p>
      </footer>
    </div>
  );
};

export default (withStyles(styles, {withTheme: true})(OptInSplash));
